import { useEffect } from 'react'
import { matchPath, useLocation } from 'react-router-dom'

import {
  useDeleteViewByCodeMutation,
  useDeleteViewMutation,
  useFetchAllObjectQuery,
  useFetchAllViewQuery,
} from '@redux/api'

import { useDebounce } from '@hooks'
import { getEntityTypeObjectForRequest } from '@helpers'
import { ENTITY, ROUTES, SEARCH_PATTERN_DELAY } from '@constants'

import { useHandlers } from './useHandlers'

export const useConfigEntities = ({ type }: { type: ENTITY }) => {
  const { pathname } = useLocation()
  const isAllEntities =
    matchPath(ROUTES.CONFIG_VIEWS, pathname) ||
    matchPath(ROUTES.CONFIG_LIST_CONTROLS, pathname) ||
    matchPath(ROUTES.CONFIG_DROP_DOWN_ENTITY, pathname)

  const [deleteView] = useDeleteViewMutation()
  const [deleteViewByCode] = useDeleteViewByCodeMutation()

  const { state, data, handlers } = useHandlers({
    deleteView,
    deleteViewByCode,
    type,
  })

  const { objectCode, searchPattern, allEntities } = state

  const { handleSetAllEntities, handleTabChange } = handlers

  const debouncedSearchPattern = useDebounce(searchPattern, SEARCH_PATTERN_DELAY)

  const { data: viewsData, isFetching: isFetchingViews } = useFetchAllViewQuery(
    {
      objectCode: objectCode ? objectCode : undefined,
      searchPattern: debouncedSearchPattern ? debouncedSearchPattern : undefined,
      ...getEntityTypeObjectForRequest(type),
    },
    { refetchOnMountOrArgChange: true }
  )
  const { data: objects } = useFetchAllObjectQuery()

  useEffect(() => {
    handleTabChange(0)
  }, [type])

  useEffect(() => {
    handleSetAllEntities(viewsData?.data || [])
  }, [viewsData])

  return {
    state: {
      ...state,
      isAllEntities,
      allEntities,
    },
    data: {
      ...data,
      isFetchingViews,
      objects,
    },
    handlers,
  }
}
